var state = {
    cognitoInfo: {},
    userGroup: '',
    loggedIn: false,
    loadingState: true,
    errorLoadingState: false
}

function setLoggedIn(newValue) {
    state.loggedIn = newValue;
}

function setLoggedOut() {
    state.loggedIn = false;
    state.userGroup='';
    state.cognitoInfo = {};
}

function setCognitoInfo(newValue) {
    state.cognitoInfo = newValue;
}

function setUserGroup(newValue) {
    state.userGroup = newValue;
}

export default {
    state: state,
    setLoggedIn: setLoggedIn,
    setLoggedOut: setLoggedOut,
    setCognitoInfo: setCognitoInfo,
    setUserGroup: setUserGroup
}
